import Http from "../services/Providers/Http";

const ENDPOINTS = {
  GET_PROJECTS: "/api/dash/getProjects",
  GET_NOTICES: "/api/dash/getNotices"
};

export default {
  getProjects: (payload, params) => {
    return Http.get(ENDPOINTS.GET_PROJECTS, params, null, payload);
  },
  getNotices: (payload, params) => {
    return Http.get(ENDPOINTS.GET_NOTICES, params, null, payload);
  },
}; 